import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { StyledDialog } from 'ui-components/ui-dialog/UiDialog.styles';

export const StyledServiceWorkerUpdateDialog = styled(StyledDialog)(
  ({ theme }) => css`
    .MuiPaper-root {
      padding: 24px;
      border-radius: 12px;

      .icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon-outline {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #e9f8ff;
      }

      .card-header {
        color: #092335;
        text-align: center;
        font-size: ${theme.typography.subtitle2.fontSize};
        font-weight: ${theme.typography.subtitle2.fontWeight};
        line-height: ${theme.typography.subtitle2.lineHeight};
        padding-bottom: 12px;
      }
      .card-body {
        text-align: center;
        font-size: ${theme.typography.body.fontSize};
        font-weight: ${theme.typography.body.fontWeight};
        line-height: ${theme.typography.body.lineHeight};
        padding-right: 0;
        padding-left: 0;
      }

      .card-footer {
        padding: 0;
        justify-content: space-between;
      }
    }
  `
);
